import api from "@/plugins/api";

export const fetchMeal = async (
  { commit },
  params = {
    next_page: 1,
    last_page: 1,
    per_page: 10,
    total: 0
  }
) => {
  const response = await api({
    method: "POST",
    endpoint: "recipes",
    body: {
      pagination: params
    }
  });

  const { data } = response;

  commit("resetMyRecipes");
  commit("allRecipesMutation", data);
};

export const fetchPastMealPlans = async ({ commit }) => {
  const response = await api({
    method: "GET",
    endpoint: "past_meal_plans"
  });

  const { data } = response;

  commit("resetPastMealPlans");
  commit("allPastMealPlans", data);
};
